import { COLUMN_CATEGORY, COLUMN_COMPANY, COLUMN_DATE_TIME, COLUMN_DEPARTMENT, COLUMN_DEVICE, COLUMN_DOOR, COLUMN_EVENT, COLUMN_NAME, COLUMN_SITE, COLUMN_TAG_CODE, COLUMN_ZONE } from "../../constants/column-types";
import { FILTER_COMPANIES, FILTER_DEPARTMENTS, FILTER_DOORS, FILTER_EVENTS, FILTER_PROFILE, FILTER_SITES, FILTER_ZONES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const LiveTransactionsWidgetColumns: TableColumn[] = [
    {
        heading: "Event",
        accessor: "name",
        isNumeric: false,
        id: 1,
        active: true,
        searchOnName: "eventId",
        lookupName: 'event',
        translationKey: "event",
        columnId: COLUMN_EVENT,
        filterId: FILTER_EVENTS,
        settingDataName: 'eventType',
        hideLookup: true,
    },
    {
        heading: "Source",
        accessor: "device",
        isNumeric: false,
        id: 2,
        active: true,
        searchOnName: "deviceId",
        lookupName: 'device',
        translationKey: "source",
        columnId: COLUMN_DEVICE,
        hideLookup: true
    },
    {
        heading: "Name",
        accessor: "credentialHolder",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "name",
        columnId: COLUMN_NAME,
        hideLookup: true,

    },
    {
        heading: "Date/Time",
        accessor: "dateTime",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "dateTime",
        columnId: COLUMN_DATE_TIME,
        hideLookup: true,
    },
    {
        heading: "Card Number",
        accessor: "tagCode",
        isNumeric: false,
        id: 5,
        active: false,
        translationKey: "tagCode",
        columnId: COLUMN_TAG_CODE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 6,
        active: false,
        searchOnName: "siteId",
        lookupName: 'site',
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site',
        hideLookup: true,
    },
    {
        heading: "Zone",
        accessor: "zone",
        isNumeric: false,
        id: 8,
        active: false,
        searchOnName: "zoneId",
        lookupName: 'zone',
        translationKey: "zone",
        columnId: COLUMN_ZONE,
        filterId: FILTER_ZONES,
        settingDataName: 'zone',
        hideLookup: true,
    },
    {
        heading: "Category",
        accessor: "category",
        isNumeric: false,
        id: 9,
        active: false,
        searchOnName: "categoryId",
        lookupName: 'category',
        translationKey: "category",
        columnId: COLUMN_CATEGORY,
        filterId: FILTER_PROFILE,
        settingDataName: "profile",
        hideLookup: true,
    },
    {
        heading: "Department",
        accessor: "department",
        isNumeric: false,
        id: 15,
        sortByName: "trDeptName",
        lookupName: "department.deptName",
        searchOnName: "departmentId",
        active: false,
        translationKey: "department",
        columnId: COLUMN_DEPARTMENT,
        settingDataName: 'department',
        filterId: FILTER_DEPARTMENTS,
        hideLookup: true,
    },
    {
        heading: "Company",
        accessor: "company",
        isNumeric: false,
        id: 13,
        lookupName: "company.compName",
        searchOnName: "companyId",
        active: false,
        translationKey: "company",
        columnId: COLUMN_COMPANY,
        settingDataName: 'company',
        filterId: FILTER_COMPANIES,
        hideLookup: true,
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 7,
        active: false,
        searchOnName: "doorId",
        lookupName: 'door',
        translationKey: "door",
        columnId: COLUMN_DOOR,
        settingDataName: 'location',
        filterId: FILTER_DOORS,
        hideLookup: true,
    },
]

export default LiveTransactionsWidgetColumns;
